import React, { useMemo } from 'react';
import { View, Text, FlatList, Image, Dimensions, useWindowDimensions } from 'react-native';
import { SUB_WIDGET_LIST } from '../../navigation/StackNavigator/routes';
import { useTranslation } from 'react-i18next';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useNavigation } from '@react-navigation/native';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomFlatList from '../customFlatList';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';

const MultipleSmallWidgetScroll = props => {
  const { listItemData, handleOnWidgetClick, widget } = props || {};

  const { t } = useTranslation();
  const { width } = useWindowDimensions()
  const navigation = useNavigation();
  const getStyles = useCssStyle();



  const handleListAll = () => {
    navigation.navigate(SUB_WIDGET_LIST, { listItemData, widget })
  }

  const renderItem = ({ item }) => {
    const widgetImg = getCleanUrl(item?.btnImageUrl);
    const listItemDescription = getStyles(['multipleSmallWidget_WidgetsSubTitleText', `multipleSmallWidget_WidgetsSubTitleText_${item.widgetMetaHtmlId}`]);
    return (
        <CustomPressable id={`multipleSmallWidget_WidgetsContainer multipleSmallWidget_WidgetsContainer_${item.widgetMetaHtmlId}`} style={getStyles(['multipleSmallWidget_WidgetsContainer', `multipleSmallWidget_WidgetsContainer_${item.widgetMetaHtmlId}`])} onPress={() => handleOnWidgetClick(item)}>

          <ImageComp
            source={widgetImg}
            style={getStyles(['multipleSmallWidget_WidgetsImg', `multipleSmallWidget_WidgetsImg_${item.widgetMetaHtmlId}`])}
            id={`multipleSmallWidget_WidgetsImg multipleSmallWidget_WidgetsImg_${item.widgetMetaHtmlId}`}
          />

          <View 
            style={getStyles(['multipleSmallWidget_WidgetsTitleContainer', `multipleSmallWidget_WidgetsTitleContainer_${item.widgetMetaHtmlId}`])} 
            id={`multipleSmallWidget_WidgetsTitleContainer  multipleSmallWidget_WidgetsTitleContainer_${item.widgetMetaHtmlId}`} 
          >
            {item?.widgetTitle && 
              <Text 
                style={getStyles(['multipleSmallWidget_WidgetsTitleText', `multipleSmallWidget_WidgetsTitleText_${item.widgetMetaHtmlId}`])} 
                id={`multipleSmallWidget_WidgetsTitleText multipleSmallWidget_WidgetsTitleText_${item.widgetMetaHtmlId}`}
              >{item?.widgetTitle}</Text>}

            {item?.widgetDesc && 
              <RenderHTML 
                contentWidth={width}
                baseStyle={listItemDescription}
                source={{ html: item?.widgetDesc }}
                systemFonts={[listItemDescription.fontFamily]}
                id={`multipleSmallWidget_WidgetsSubTitleText multipleSmallWidget_WidgetsSubTitleText_${item.widgetMetaHtmlId}`}
              />}
            
            {item.buttonTitle &&
              <View 
                onPress={handleOnWidgetClick} 
                style={getStyles(['multipleSmallWidget_WidgetsButtonContainer', `multipleSmallWidget_WidgetsButtonContainer_${item.widgetMetaHtmlId}`])} 
                id={`multipleSmallWidget_WidgetsButtonContainer multipleSmallWidget_WidgetsButtonContainer_${item.widgetMetaHtmlId}`}
              >
                <Text 
                  style={getStyles(['multipleSmallWidget_WidgetsButtonContainerText', `multipleSmallWidget_WidgetsButtonContainerText_${item.widgetMetaHtmlId}`])} 
                  id={`multipleSmallWidget_WidgetsButtonContainerText multipleSmallWidget_WidgetsButtonContainerText_${item.widgetMetaHtmlId}`}
                >{item.buttonTitle}</Text>
              </View>
            }
          </View>
        </CustomPressable>
    )
  }


  const customWidgetTitleStyle = useMemo(() => {
      const style = getStyles(['multipleSmallWidgetTitleText', `multipleSmallWidgetTitleText_${listItemData[0]?.widgetMetaHtmlId}`]);
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const customWidgetDescriptioneStyle = useMemo(() => {
      const style = getStyles(['multipleSmallWidgetDescriptionText', `multipleSmallWidgetDescriptionText_${listItemData[0]?.widgetMetaHtmlId}`]);
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  return (
    <View style={getStyles(['multipleSmallWidgetContainer', `multipleSmallWidgetContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`multipleSmallWidgetContainer multipleSmallWidgetContainer_${listItemData[0]?.widgetMetaHtmlId}`} >

      <View style={getStyles(['multipleSmallWidgetTitleContainer', `multipleSmallWidgetTitleContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`multipleSmallWidgetTitleContainer multipleSmallWidgetTitleContainer_${listItemData[0]?.widgetMetaHtmlId}`} >
        <View style={getStyles(['multipleSmallWidgetTitleTextContainer', `multipleSmallWidgetTitleTextContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`multipleSmallWidgetTitleTextContainer multipleSmallWidgetTitleTextContainer_${listItemData[0]?.widgetMetaHtmlId}`}>
          {widget?.displayName && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetTitleStyle}
              source={{ html: widget?.displayName}}
              systemFonts={[customWidgetTitleStyle.fontFamily]}
              id={`multipleSmallWidgetTitleText multipleSmallWidgetTitleText_${listItemData[0]?.widgetMetaHtmlId}`}
          />}
          {widget?.widgetDesc && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetDescriptioneStyle}
              source={{ html: widget?.widgetDesc}}
              systemFonts={[customWidgetDescriptioneStyle.fontFamily]}
              id={`multipleSmallWidgetDescriptionText multipleSmallWidgetDescriptionText_${listItemData[0]?.widgetMetaHtmlId}`}
          />}
        </View>
        <CustomPressable onPress={handleListAll}>
          <Text style={getStyles(['multipleSmallWidgetViewAllTxt', `multipleSmallWidgetViewAllTxt_${listItemData[0]?.widgetMetaHtmlId}`])} id={`multipleSmallWidgetViewAllTxt multipleSmallWidgetViewAllTxt_${listItemData[0]?.widgetMetaHtmlId}`} >{t('home_page.view_all')}</Text>
        </CustomPressable>
      </View>
      
      <CustomFlatList
        data={listItemData}
        renderItem={renderItem}
        contentContainerStyle={getStyles(['multipleSmallWidget_MainWidgetsContainer', `multipleSmallWidget_MainWidgetsContainer_${listItemData[0]?.widgetMetaHtmlId}`])}
        keyExtractor={item => item?.widgetId}
        horizontal
        showsHorizontalScrollIndicator={false}
        id={`multipleSmallWidget_MainWidgetsContainer multipleSmallWidget_MainWidgetsContainer_${listItemData[0]?.widgetMetaHtmlId}`}
      />
    </View>
  );
};

export default React.memo(MultipleSmallWidgetScroll);
